import { z } from 'zod';

export const DocumentUserSchema = z.object({
  displayName: z.string(),
  isAccure: z.boolean(),
});

export type DocumentUser = z.infer<typeof DocumentUserSchema>;
